import { render } from "./icon-angle-down.vue?vue&type=template&id=53d77fb4"
import script from "./icon-angle-down.vue?vue&type=script&lang=js"
export * from "./icon-angle-down.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__